import { IRawLocation } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

export class Location implements IRawLocation {
  static build(location: IRawLocation) {
    return new Location(location);
  }
  id: number;
  campus: number;
  campus_name: string;
  name: string;
  address: string;
  comments: string;
  latitude: string;
  longitude: string;

  constructor(location: IRawLocation) {
    const NULLABLE_DEFAULTS = {
      campus_name: '',
      name: '',
      address: '',
      comments: '',
      latitude: '',
      longitude: ''
    };
    _4.merge(this, NULLABLE_DEFAULTS, location);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/builders/location_builder.ts